var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "mt-4 admin-steffi-booking-card",
      attrs: { outlined: "", "data-test": "steffi-admin-booking-card" },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "9" } },
            [
              _c("v-card-title", { staticClass: "v-application" }, [
                _c("span", [_vm._v("Steffi hinzufügen")]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-btn-toggle",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        color: "blue accent-3",
                        mandatory: "",
                        "data-test": "steffi-admin-booking-mode",
                      },
                      model: {
                        value: _vm.adminBookingMode,
                        callback: function ($$v) {
                          _vm.adminBookingMode = $$v
                        },
                        expression: "adminBookingMode",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { small: "", height: "40", value: "invite" } },
                        [_vm._v("Einladung per E-Mail senden")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", height: "40", value: "offline" },
                        },
                        [_vm._v("Vertragsset wurde offline angenommen")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", height: "40", value: "existing" },
                        },
                        [_vm._v("Bestandsvertrag importieren")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "v-application--is-ltr" },
                [
                  _c(
                    "v-row",
                    { staticClass: "v-application", attrs: { dense: "" } },
                    [
                      _vm.adminBookingMode == "invite"
                        ? [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.planItems,
                                    dense: "",
                                    outlined: "",
                                    label: "Paket",
                                    "hide-details": "",
                                    "data-test": "steffi-admin-invitation-plan",
                                  },
                                  model: {
                                    value: _vm.adminInvitationForm.plan_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminInvitationForm,
                                        "plan_code",
                                        $$v
                                      )
                                    },
                                    expression: "adminInvitationForm.plan_code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type: "email",
                                    label: "Empfänger E-Mail",
                                    "hide-details": "",
                                    "data-test":
                                      "steffi-admin-invitation-email",
                                  },
                                  model: {
                                    value:
                                      _vm.adminInvitationForm.invited_email,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminInvitationForm,
                                        "invited_email",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "adminInvitationForm.invited_email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm.adminBookingMode == "offline"
                        ? [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.planItems,
                                    dense: "",
                                    outlined: "",
                                    label: "Paket",
                                    "hide-details": "",
                                    "data-test": "steffi-admin-booking-plan",
                                  },
                                  model: {
                                    value: _vm.adminBookingForm.plan_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminBookingForm,
                                        "plan_code",
                                        $$v
                                      )
                                    },
                                    expression: "adminBookingForm.plan_code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type: "date",
                                    label: "Vertrags-/Annahmedatum",
                                    "hide-details": "",
                                    "data-test": "steffi-admin-booking-date",
                                  },
                                  model: {
                                    value: _vm.adminBookingForm.accepted_at,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminBookingForm,
                                        "accepted_at",
                                        $$v
                                      )
                                    },
                                    expression: "adminBookingForm.accepted_at",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    label:
                                      "Mit kostenloser 14-tägiger Testphase starten",
                                    "data-test": "steffi-admin-booking-trial",
                                  },
                                  model: {
                                    value: _vm.adminBookingForm.trial_requested,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminBookingForm,
                                        "trial_requested",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "adminBookingForm.trial_requested",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    label:
                                      "Das Vertragsset einschließlich Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung wurde angenommen.",
                                    "data-test":
                                      "steffi-admin-booking-contract",
                                  },
                                  model: {
                                    value:
                                      _vm.adminBookingForm
                                        .accepted_contract_terms,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminBookingForm,
                                        "accepted_contract_terms",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "adminBookingForm.accepted_contract_terms",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-textarea", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "auto-grow": "",
                                    rows: "2",
                                    "hide-details": "",
                                    label: "Interne Notiz",
                                    "data-test": "steffi-admin-booking-note",
                                  },
                                  model: {
                                    value: _vm.adminBookingForm.internal_note,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.adminBookingForm,
                                        "internal_note",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "adminBookingForm.internal_note",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-alert",
                                  {
                                    attrs: {
                                      type: "info",
                                      outlined: "",
                                      dense: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Die bisherigen Rechnungen werden nicht erneut erzeugt. Ab dem automatischen\n                                Abrechnungsbeginn gelten dauerhaft die hier erfassten Vertragspreise.\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.planItems,
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    label: "Paket",
                                    "data-test": "steffi-existing-plan",
                                  },
                                  model: {
                                    value: _vm.existingCustomerForm.plan_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "plan_code",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.plan_code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    type: "date",
                                    label: "Startdatum des Bestandsvertrags",
                                    "data-test": "steffi-existing-start-date",
                                  },
                                  model: {
                                    value: _vm.existingCustomerForm.accepted_at,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "accepted_at",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.accepted_at",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    type: "date",
                                    label: "Automatische Abrechnung ab",
                                    "data-test":
                                      "steffi-existing-billing-start-date",
                                  },
                                  model: {
                                    value:
                                      _vm.existingCustomerForm
                                        .automated_billing_start_date,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "automated_billing_start_date",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.automated_billing_start_date",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    inputmode: "decimal",
                                    suffix: "€ netto",
                                    label: "Einrichtungspreis laut Vertrag",
                                    "data-test": "steffi-existing-setup-net",
                                  },
                                  model: {
                                    value: _vm.existingCustomerForm.setup_net,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "setup_net",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.setup_net",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    inputmode: "decimal",
                                    suffix: "€ netto",
                                    label: "Monatspreis laut Vertrag",
                                    "data-test": "steffi-existing-monthly-net",
                                  },
                                  model: {
                                    value: _vm.existingCustomerForm.monthly_net,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "monthly_net",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.monthly_net",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                    inputmode: "decimal",
                                    suffix: "€ netto",
                                    label: "Minutenpreis laut Vertrag",
                                    "data-test": "steffi-existing-usage-net",
                                  },
                                  model: {
                                    value:
                                      _vm.existingCustomerForm.usage_minute_net,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "usage_minute_net",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.usage_minute_net",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-textarea", {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    "auto-grow": "",
                                    rows: "2",
                                    "hide-details": "",
                                    label: "Interne Notiz",
                                    "data-test": "steffi-existing-note",
                                  },
                                  model: {
                                    value:
                                      _vm.existingCustomerForm.internal_note,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.existingCustomerForm,
                                        "internal_note",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "existingCustomerForm.internal_note",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _vm.adminBookingMode == "invite"
                    ? _c(
                        "v-row",
                        { staticClass: "d-flex align-center" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass:
                                    "mb-0 mx-3 v-application--is-ltr body-2",
                                  attrs: {
                                    type: "success",
                                    dense: "",
                                    text: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Die Apotheke bestätigt das vollständige Vertragsset einschließlich\n                            Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung über den Link.\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    width: "335",
                                    color: "primary",
                                    disabled: !_vm.canSendAdminInvitation,
                                    loading: _vm.isSendingAdminInvitation,
                                    "data-test":
                                      "steffi-admin-invitation-submit",
                                  },
                                  on: { click: _vm.sendAdminInvitation },
                                },
                                [
                                  _vm._v(
                                    "\n                            Einladung senden\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            color: "primary",
                            disabled: !_vm.canSubmitCurrentBooking,
                            loading: _vm.isCreatingAdminBooking,
                            "data-test": "steffi-admin-booking-submit",
                            width: "335",
                          },
                          on: { click: _vm.createAdminBooking },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.adminBookingMode == "existing"
                                  ? "Bestandsvertrag importieren"
                                  : "Steffi hinzufügen"
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center pr-7",
              attrs: { cols: "12", lg: "3" },
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mt-2 mb-0 v-application--is-ltr",
                  attrs: { color: "cyan darken-2", dense: "", outlined: "" },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-1 mb-1", attrs: { color: "cyan" } },
                    [_vm._v("mdi-information")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "body-2" }, [
                    _vm._v(
                      "\n                    Wählen Sie, ob die Apotheke das Vertragsset selbst bestätigen soll oder ob es\n                    bereits offline angenommen wurde. Bei einer Einladung wird noch keine Rechnung\n                    ausgelöst; bei der Offline-Annahme ohne Testphase wird die Buchung mit\n                    Einrichtungsrechnung zum Annahmedatum angelegt. Mit Testphase erfolgt die\n                    Abrechnung erst nach einer späteren kostenpflichtigen Buchung. Die technische\n                    Aktivierung erfolgt separat.\n                "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }